import * as React from 'react';
import styled from 'styled-components';
import { Label } from '../../designSystem/Label';
import { Flex } from '../compositeComponents/FlexHelpers';
import { InputMessage } from '../InputMessage';
import { ToggletipTheOne } from '../ToggletipTheOne';
import { Icon, iconName } from '../icons/Icons';

type FormFieldProps = {
    label: string,
    inputComponent: React.ReactNode,
    message?: string,
    inErrorState?: boolean,
    toolTip?: React.ReactNode,
    hideLabel?: boolean,
    reserveMessageSpace?: boolean,
    style?: React.CSSProperties,
    leadingIcon?:iconName
};

export function FormField (props: FormFieldProps)
{
    return (    
        <FormFieldWrapper style={{ ...props.style }}>
            <Flex flexDirection="column" gap={2}>
                <Flex alignItems='center' gap={4}>
                    <Label errorState={props.inErrorState} formIndent hide={props.hideLabel}>
                        {props.label === '' ? '\u00A0' : props.label    }
                    </Label>    
                    {props.toolTip !== undefined && props.toolTip !== '' &&
                        <ToggletipTheOne>
                            {props.toolTip} 
                        </ToggletipTheOne>
                    }
                </Flex>

                {props.leadingIcon
                    ?   <Flex alignItems='center' gap={2}>
                            <Icon name={props.leadingIcon} />
                            <div style={{ flex: 1 }}>{props.inputComponent}</div>
                        </Flex>
                    :   props.inputComponent
                }

                
                <div style={{ minHeight: props.reserveMessageSpace === true ? '24px' : '0px' }}>

                    {props.message !== undefined && props.message !== '' &&
                        <InputMessage inErrorState={props.inErrorState}>
                            {props.message}
                        </InputMessage>
                    }
                </div>
            </Flex>
        </FormFieldWrapper>
    );
}

export const FormFieldWrapper = styled.div<{ marginBottom?: number; }>`
    min-height: 20px;
    margin-bottom: ${props => props.marginBottom !== undefined ? props.marginBottom + 'px' : '0'};
`;

export const formFieldValidationHelper = (value: string, infoMessage?: string, errorMessage?: string, validator?: (value: string) => { valid: true; } | { valid: false, errorMessage: string; }) =>
{

    // Priority:
    // 1. errorMessage
    if (errorMessage)
        return { inErrorState: true, message: errorMessage };

    // 2. validator result
    if (validator)
    {
        const validatorResult = validator(value);
        if (validatorResult.valid === false)
            return { inErrorState: true, message: validatorResult.errorMessage };

        return { inErrorState: false, message: infoMessage || '' };
    }

    // 3. infoMessage (no error)
    return { inErrorState: false, message: infoMessage || '' };
};
